<template>
    <svg aria-hidden="true" focusable="false" width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20.5" cy="20.5" r="20" stroke="#9D9FA2" />
        <path d="M17.3864 17.9318H14.25V27.9321H17.3864V17.9318Z" fill="black" />
        <path
            d="M25.8642 17.7093C25.7457 17.6963 25.6243 17.6869 25.5007 17.6819C23.745 17.6103 22.7523 18.6522 22.4098 19.0965C22.3188 19.2157 22.2733 19.2923 22.2733 19.2923V17.9542H19.2734V27.9545H22.4098V23.256C22.4098 22.5776 22.3571 21.8522 22.6967 21.2359C22.9842 20.7149 23.5037 20.4541 24.0918 20.4541C25.8237 20.4541 25.8649 22.0212 25.8649 22.1701V28H29.0013V21.4772C29.0013 19.2454 27.867 17.9253 25.8649 17.7093H25.8642Z"
            fill="black" />
        <path
            d="M15.8186 16.6371C16.8229 16.6371 17.6371 15.8229 17.6371 14.8186C17.6371 13.8142 16.8229 13 15.8186 13C14.8142 13 14 13.8142 14 14.8186C14 15.8229 14.8142 16.6371 15.8186 16.6371Z"
            fill="black" />
    </svg>
</template>
